// @ts-strict-ignore
import {FUNNELS_MATH_TYPES} from 'common/types/reports/bookmark';
import {CountType} from 'common/report/funnels/models/types';
import {getBehaviorShowClauses} from 'common/report/insights/models/utils';
import {ShowClause} from 'common/report/insights/util/types';

export function getCountType(showClauses: ShowClause[]): CountType {
  const countType = getBehaviorShowClauses(showClauses)[0]?.measurement.math;
  // Subset of count types for now since new metrics dont follow the same rules atm
  if (isPropSum(showClauses)) {
    return CountType.PropertySum;
  }
  return {
    [FUNNELS_MATH_TYPES.CONVERSION_RATE_UNIQUE]: CountType.ConversionRate,
    [FUNNELS_MATH_TYPES.CONVERSION_RATE_TOTAL]: CountType.ConversionRate,
    [FUNNELS_MATH_TYPES.CONVERSION_RATE_SESSION]: CountType.ConversionRate,
    [FUNNELS_MATH_TYPES.GENERAL]: CountType.General,
    [FUNNELS_MATH_TYPES.SESSION]: CountType.Session,
    [FUNNELS_MATH_TYPES.UNIQUE]: CountType.Unique,
  }[countType as FUNNELS_MATH_TYPES];
}

export function getPropSumProp(showClauses: ShowClause[]) {
  return getBehaviorShowClauses(showClauses)[0].measurement.property;
}

function isPropSum(showClauses: ShowClause[]) {
  return !!getPropSumProp(showClauses);
}
